import React, { useEffect, useRef } from 'react';

const OverboxInfoVideoModal = ({ onClose, videoId = '9ftbmDMdSF8' }) => {
    const iframeRef = useRef(null);

    useEffect(() => {
        const handleMessage = (event) => {
            if (typeof event.origin !== 'string' || !event.origin.includes('youtube.com')) return;
            let data = event.data;
            if (typeof data === 'string') {
                try {
                    data = JSON.parse(data);
                } catch (e) {
                    return;
                }
            }
            if (data && data.event === 'onStateChange' && data.info === 0) {
                onClose();
            }
        };

        const handleKeyDown = (event) => {
            if (event.key === 'Escape') onClose();
        };

        window.addEventListener('message', handleMessage);
        window.addEventListener('keydown', handleKeyDown);

        const handshakeTimer = setTimeout(() => {
            if (iframeRef.current && iframeRef.current.contentWindow) {
                iframeRef.current.contentWindow.postMessage(
                    JSON.stringify({ event: 'listening', id: videoId, channel: 'widget' }),
                    '*'
                );
            }
        }, 500);

        return () => {
            window.removeEventListener('message', handleMessage);
            window.removeEventListener('keydown', handleKeyDown);
            clearTimeout(handshakeTimer);
        };
    }, [onClose, videoId]);

    const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&enablejsapi=1&playsinline=1&rel=0&modestbranding=1`;

    return (
        <div className='OverboxVideoOverlay' onClick={onClose}>
            <div className='OverboxVideoContainer' onClick={(e) => e.stopPropagation()}>
                <span className='OverboxVideoClose' onClick={onClose}>X</span>
                <iframe
                    ref={iframeRef}
                    src={embedUrl}
                    title="¿Qué es Overbox?"
                    frameBorder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                />
            </div>
        </div>
    );
};

export default OverboxInfoVideoModal;
